'use strict';

angular.module('amexReconciliationApp')
  .service('TransactionRepository', function ($http,
                                              $q,
                                              $resource,
                                              TransactionSearchModel) {
    var self = this;
    var findByIdResource = $resource('/api/v1/transactions/search/findById');

    function unpackTransactions(response) {
      return _.get(response.toJSON(), '_embedded.transactions', []);
    }

    self.getTransactions = function (transactionIds) {
      return findByIdResource.get({ ids: _.join(transactionIds, ',') })
        .$promise
        .then(function (resource) {
          return _.get(resource.toJSON(), '_embedded.transactions', []);
        });
    };

    self.runTransactionSearch = function (transactionsUri) {
      if(!TransactionSearchModel.billingCycle()) {
        return $q.when([]);
      }

      return $resource(transactionsUri)
        .get(TransactionSearchModel.queryParams())
        .$promise
        .then(unpackTransactions);
    };

    self.runTransactionCount = function (transactionsUri) {
      if(!TransactionSearchModel.billingCycle()) {
        return $q.when({numberOfTransactions: 0});
      }

      return $resource(transactionsUri)
        .get(TransactionSearchModel.queryParams())
        .$promise;
    };

    self.fetchAllocations = function (allocationsUri) {
      return $resource(allocationsUri)
        .get(TransactionSearchModel.queryParams())
        .$promise;
    };

    self.updateTransactions = function (transactions) {
      return $http.patch('/api/v1/transactions', transactions);
    };

  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/repositories/TransactionRepository.js
// module id = 627
// module chunks = 0